import AccountSettings from './account';
import TripListing from './trip';
import BookingProcess from './booking';
import PaymentProcess from './payment';
import PostTripProcess from './postTrip';
import Cancellation from './cancellation';

export default [
  AccountSettings,
  TripListing,
  BookingProcess,
  PaymentProcess,
  PostTripProcess,
  Cancellation
];
